












































































import { Component, Prop, Vue } from "vue-property-decorator";

import { DateHelper } from "@/helper/dateHelper";
import { CookieHelper } from "@/helper/cookieHelper";
import { NativeHelper } from "@/helper/nativeHelper";
import { UserAgentHelper } from "@/helper/userAgentHelper";
import { UserConfigColors } from "@/userConfigColors/userConfigColors";

import { TermsOfService } from "@/termsOfService/termsOfService";

import CheckBoxOn from "../../resources/checkBoxOn.vue";

@Component({
  components: {
      CheckBoxOn
  }
})
export default class License extends Vue {
    isCheck = false;

    private termsOfService = new TermsOfService();

    mounted()
    {
        // モーダル表示モード: ON
        this.$store.getters.applicationState.modalMode = 1;
    }

    destroyed()
    {
        // モーダル表示モード: OFF
        this.$store.getters.applicationState.modalMode = 0;
    }

    private cancel()
    {
        if(UserAgentHelper.isElectron())
        {
            // ネイティブでアプリを強制終了させる
            NativeHelper.sendNativeEvent("quit_application", { isForce : "true" });
        }
        else
        {
            window.close();
            location.href = "about:blank";
        }
    }

    private goNext(){
        CookieHelper.setItem("license", this.isCheck);
        this.$emit("close");
    }

    //configcolor
    private get userConfigColors() : UserConfigColors{
        return this.$store.getters.userConfigColors;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        };
    }
}
